<template>
  <div>
    <sys-dialog
      v-model="dialog"
      titulo="Lista de pedidos DRP vencidos"
      txtBotao="Finalizar pedidos"
      :largura="750"
      :ocultarBotaoSalvar="desserts.length == 0"
      @click:primary="finalizarPedidosVencidos()"
    >
      <SysDataTable
        v-model="itens_selecionados"
        :headers="headers"
        :items="desserts"
        :height="450"
        :item-height="45"
        :search="search"
        :loading="loading"
        item-key="idpedido"
        hide-default-footer
        show-select
      />
    </sys-dialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysDataTable from '@/components/utils/dataTable/sysDataTable/Index.vue';
import { buscarListasDePedidosVencidosDrp, finalizarPedidosVencidosDrp } from './PedidosVencidosApi';
import { logout } from '@/helpers';

export default {
  components: { SysDialog, SysDataTable },
  props: {
    dialog_vencidos: {
      type: Boolean,
      required: true
    }
  },
  model: {
    prop: 'dialog_vencidos',
    event: 'change:dialog_vencidos'
  },
  computed: {
    DIALOG_ATIVO: {
      get() { return this.dialog_vencidos },
      set(valor) { this.$emit('change:dialog_vencidos', valor) }
    }
  },
  created() {
    this.buscarListasDePedidosVencidos();
  },
  data() {
    return {
      dialog: false,
      search: '',
      loading: true,
      itens_selecionados: [],
      headers: [
        { text: 'ID Pedido', value: 'idpedido' },
        { text: 'Usuário', value: 'nome_usuario' },
        { text: 'Data Emissão', value: 'data_emissao' },
        { text: 'Filial Destino', value: 'filiais_destino' },
        { text: 'Qtde. Pedido', value: 'qtde_pedido' },
      ],
      desserts: []
    }
  },
  watch: {
    DIALOG_ATIVO(valor) {
      if (valor) this.buscarListasDePedidosVencidos();
    },
    desserts(valor) {
      if (valor.length > 0) this.dialog = true;
      else this.dialog = false;

      this.$emit('change:dialog_vencidos', false);
    }
  },
  methods: {
    buscarListasDePedidosVencidos() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarListasDePedidosVencidosDrp()
          .then(dados => {
            this.desserts = dados.lista;
            this.itens_selecionados = dados.lista;
          })
          .catch(logout)
          .finally(() => this.loading = false)
      );
    },
    finalizarPedidosVencidos() {
      this.$store.dispatch(
        'loading/addRequisicao',
        finalizarPedidosVencidosDrp(this.itens_selecionados)
          .then(() => {
            this.desserts = [];
            this.itens_selecionados = [];
            this.$emit('change:dialog_vencidos', false)
            this.$emit('atualizar-pedidos', false)
          })
          .catch(logout)
          .finally(() => this.loading = false)
      );
    }
  }
}
</script>

<style>

</style>
